import { render } from "./MinusButton.vue?vue&type=template&id=7883666a&scoped=true"
const script = {}

import "./MinusButton.vue?vue&type=style&index=0&id=7883666a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7883666a"]])

export default __exports__